import React from 'react'
import '../../Styles/Service.css'
import '../../assets/css/flaticon.css'
import '../../Styles/Theme.css'
import '../../assets/css/custom-animation.css'
import { Link } from "react-router-dom"


const Service = () => {
    return (
        <div>
            <section className="bd-service-area main-top-service pt-80 pb-50 gray-bg">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-4 col-md-6 pt-20">
                            <div className="bd-section-title-wrapper mb-50">
                                <h5 className="bd-section-subtitle mb-15 subtitle-without-border">Our Services</h5>
                                <h2 className="bd-section-title">Be a <br />Pioneer in <span style={{ color: "#ffbf1e" }}>Innovation</span></h2>
                            </div>
                        </div>

                        <div className="col-lg-4 col-md-6">
                            <div className="bd-service mb-30">
                                <div className="bd-service-icon mb-20">
                                    <i>
                                        <img src="https://res.cloudinary.com/ztpl-images/image/upload/q_auto,f_auto,fl_lossy/v1659451034/website/icons/business-automation-icon_glwtlf.png" />
                                    </i>
                                </div>
                                <h4 className="bd-service-title mb-20"><Link to={"/ca/business-automation"}>Business Automation</Link></h4>
                                <p>Our expertise lies in aiding businesses within the business landscape through process automation, enhancing profits, managing risk, and achieving long-term sustainable growth in USA. 
                                .</p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div className="bd-service mb-30">
                                <div className="bd-service-icon mb-20" >
                                    <i >
                                        <img src="https://res.cloudinary.com/ztpl-images/image/upload/q_auto,f_auto,fl_lossy/v1659451034/website/icons/bespoke-system-icon_fa3bts.png" />
                                    </i>
                                </div>
                                <h4 className="bd-service-title mb-20"><Link to={"/ca/digital-marketing"}>Digital Marketing</Link></h4>
                                <p>Our digital marketing services in USA drive growth and boost brand visibility, ensuring businesses reach their target audience effectively, and maximizing their online presence and conversion rates.</p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div className="bd-service mb-30">
                                <div className="bd-service-icon mb-20">
                                    <i>
                                        <img src="https://res.cloudinary.com/ztpl-images/image/upload/q_auto,f_auto,fl_lossy/v1659451034/website/icons/software-development-icon_kstwkg.png" />
                                    </i>
                                </div>
                                <h4 className="bd-service-title mb-20"><Link to={"/ca/custom-software-development"} >Custom Software Development</Link></h4>
                                <p>
                                    In Canada, our experts create custom software tailored to your vision, optimizing your operations and keeping you ahead in the digital world.

                                    {/* In the business realm, Software development entails the creation, design, programming, testing, and ongoing maintenance of computer programs, applications, and systems. */}
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div className="bd-service mb-30">
                                <div className="bd-service-icon mb-20" >
                                    <i>
                                        <img src="https://res.cloudinary.com/ztpl-images/image/upload/q_auto,f_auto,fl_lossy/v1659451034/website/icons/mobile-apps-icon_oxjcze.png" />
                                    </i>
                                </div>
                                <h4 className="bd-service-title mb-20"><Link to={"/ca/mobile-apps-development"}>Mobile Apps Development</Link></h4>
                                <p>In the context of business growth in Canada, mobile app development involves creating software applications designed to run seamlessly on mobile devices, such as smartphones and tablets.</p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div className="bd-service mb-30">
                                <div className="bd-service-icon mb-20" >
                                    <i>
                                        <img src="https://res.cloudinary.com/ztpl-images/image/upload/q_auto,f_auto,fl_lossy/v1659451034/website/icons/dedicate-resource-icon_rr9dis.png" />
                                    </i>
                                </div>
                                <h4 className="bd-service-title mb-20"><Link to={"/ca/website-development"}>Website Development</Link></h4>
                                <p>In the Canadian business landscape, website development encompasses crafting and maintaining web-based assets, involving design, coding, and performance optimization to drive digital growth.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </div>
    )
}

export default Service